import { render, staticRenderFns } from "./FormFieldTextArea.vue?vue&type=template&id=65a79b42&scoped=true&"
import script from "./FormFieldTextArea.vue?vue&type=script&lang=ts&"
export * from "./FormFieldTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./FormFieldTextArea.vue?vue&type=style&index=0&id=65a79b42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a79b42",
  null
  
)

export default component.exports